/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { ComponentRef, Injectable } from '@angular/core';
import { AbcCore } from '@barthauer/abc/core';
import { AbcPopupComponent } from '../abc-popup';
import { AbcCoreComponent } from '../abcCoreComponent';
import { AbcCoreContainerService } from '../abcCoreContainer.service';
import { AbcImageCropperComponent, AbcImageCropperMode, onCropEvent } from './abc-image-cropper.component';

@Injectable({ providedIn: 'root' })
export class AbcImageCropperService {
  private abcImageCropperCptRef: ComponentRef<AbcImageCropperComponent>;
  private ImageCropperPopup: AbcPopupComponent;
  private ImageCropperContainer: AbcCoreComponent;

  constructor(private coreContainerService: AbcCoreContainerService, private abcCore: AbcCore) {}

  public async openImageCropper(
    image: string,
    mode: AbcImageCropperMode,
    onCrop: (event: onCropEvent) => void,
    onCancel = () => {},
    imageQuality: number = 1,
    rtlEnabled = false,
    showControls = true,
    width = '100%',
    height = '100%'
  ): Promise<void> {
    this.createImageCropperComponent();

    this.abcImageCropperCptRef = this.ImageCropperPopup.openPopUp() as ComponentRef<AbcImageCropperComponent>;

    this.abcImageCropperCptRef.setInput('image', image);
    this.abcImageCropperCptRef.setInput('mode', mode);
    this.abcImageCropperCptRef.setInput('imageQuality', imageQuality);
    this.abcImageCropperCptRef.setInput('rtlEnabled', rtlEnabled);
    this.abcImageCropperCptRef.setInput('showControls', showControls);
    this.abcImageCropperCptRef.setInput('width', width);
    this.abcImageCropperCptRef.setInput('height', height);

    this.abcImageCropperCptRef.instance.onCrop.subscribe((event: onCropEvent) => {
      onCrop(event);
      this.destroyImageCropperComponent();
    });

    this.abcImageCropperCptRef.instance.onCancel.subscribe(() => {
      if (typeof onCancel === 'function') {
        onCancel();
      }
      this.destroyImageCropperComponent();
    });
  }

  private createImageCropperComponent(): void {
    if (!this.ImageCropperPopup) {
      this.ImageCropperContainer = this.coreContainerService.createComponent(
        this.ImageCropperContainer,
        AbcPopupComponent
      );
      this.ImageCropperPopup = this.ImageCropperContainer.componentRef.instance as AbcPopupComponent;
      this.ImageCropperPopup.component = AbcImageCropperComponent;
      this.ImageCropperPopup.resizeEnabled = false;
      this.ImageCropperPopup.showTitle = false;
      this.ImageCropperPopup.showCloseButton = false;
      this.ImageCropperPopup.width = '80dvw';
      this.ImageCropperPopup.height = '70dvh';
      this.ImageCropperPopup.minWidth = '350px';
      this.ImageCropperPopup.minHeight = '250px';
      this.ImageCropperPopup.maxWidth = '750px';
      this.ImageCropperPopup.maxHeight = '550px';
    }
  }

  public destroyImageCropperComponent(): void {
    this.ImageCropperPopup && this.ImageCropperPopup.instance.dispose();
    this.ImageCropperPopup && this.ImageCropperPopup.ngOnDestroy();
    this.ImageCropperContainer.componentRef.destroy();
    this.abcImageCropperCptRef.destroy();
    this.ImageCropperPopup = undefined;
    this.ImageCropperContainer = undefined;
  }
}
